import { motion, useReducedMotion } from "framer-motion";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";
import { StatusPill } from "../common/StatusPill";
import { MONETIZATION } from "../../constants/testIds";
import { fadeUp } from "../../lib/motion";

// UX-CP-02 §2 SCR-P08-32 "Gym billing & dunning list" — reuses the same `/control/gyms` join
// UX-CP-01 already built (plan_tier, dunning_state, seats), no new endpoint needed.
export function BillingDunningTable({ gyms, loading }) {
  const reducedMotion = useReducedMotion();
  const dunning = (gyms || []).filter((g) => g.dunning_state && g.dunning_state !== "none");

  return (
    <motion.div {...fadeUp(reducedMotion, 0.08)} className="solid-surface rounded-[14px] overflow-hidden">
      <p className="eyebrow p-5 pb-0">Billing & dunning</p>
      <Table data-testid={MONETIZATION.billingTable}>
        <TableHeader>
          <TableRow><TableHead>Gym</TableHead><TableHead>Plan</TableHead><TableHead>Status</TableHead><TableHead>Dunning</TableHead><TableHead>Seats</TableHead></TableRow>
        </TableHeader>
        <TableBody>
          {loading && <TableRow><TableCell colSpan={5} className="text-center py-6 text-sm" style={{ color: "var(--scarlet-text-secondary)" }}>Loading…</TableCell></TableRow>}
          {!loading && dunning.length === 0 && (
            <TableRow><TableCell colSpan={5} className="text-center py-6 text-sm" style={{ color: "var(--scarlet-text-secondary)" }}>No gyms in dunning right now.</TableCell></TableRow>
          )}
          {dunning.map((g) => (
            <TableRow key={g.organization_id}>
              <TableCell className="font-medium" style={{ color: "var(--scarlet-text)" }}>{g.display_name}</TableCell>
              <TableCell className="capitalize" style={{ color: "var(--scarlet-text-secondary)" }}>{g.plan_tier || "—"}</TableCell>
              <TableCell><StatusPill status={g.status} /></TableCell>
              <TableCell className="capitalize" style={{ color: "var(--status-overdue-text)" }}>{g.dunning_state}</TableCell>
              <TableCell style={{ color: "var(--scarlet-text-secondary)" }}>{g.seats_used} / {g.seat_limit ?? "—"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </motion.div>
  );
}
